blue.ready('financialJourney', '.financialJourney', content => {
  let financialJourneySelection = content.querySelector('.financialJourneySelection');
  let financialJourneyStart = content.querySelector('.financialJourneyStart');

  const topics = [...financialJourneySelection.querySelectorAll('.topic')];
  const supTopicContainer = financialJourneySelection.querySelector('.financialJourneySelection__subtopics');

  topics.forEach((topic) => {
    topic.addEventListener('click', () => {
      showParentTrack(topic);
    });
  });

  let goBack = financialJourneyStart.querySelector('.financialJourneyStart__go-back');
  goBack.addEventListener('click', (e) => {
    e.preventDefault();

    const lastTrack = getLastTrack();
    if (lastTrack && lastTrack.subTopics) {
      window.history.pushState({ last_track: getCurrentTrack(), track: lastTrack }, '', '?track=' + (lastTrack.caption || lastTrack.title));
    } else {
      window.history.pushState({ last_track: getCurrentTrack(), track: null }, '', '?track=');
      supTopicContainer.classList.remove('is-visible');
    }

    financialJourneySelection.classList.remove('is-hidden');
    financialJourneyStart.classList.remove('is-visible');
  });

  const showParentTrack = (topic, subTopic) => {
    topics.forEach(el => el.classList.remove('is-active'));
    topic.classList.add('is-active');

    let data = JSON.parse(topic.dataset.obj);

    window.history.pushState({ last_track: null, track: data }, '', '?track=' + data.caption);

    if (subTopic) {
      const indexOfSelectedSubTopic = getSubTopicIndexByTitle(data.subTopics, subTopic);

      if (indexOfSelectedSubTopic >= 0) {
        // show options (to get back button to work) and then show selection map
        showSubTopicOptions(data);
        showSelectionMap(data.subTopics[indexOfSelectedSubTopic], true);
      } else {
        showSelectionMap(data.subTopics[0], false);
      }
    } else if (data.subTopics.length <= 1) {
      // show only subtopic
      showSelectionMap(data.subTopics[0], false);
    } else {
      // show subtopic options
      showSubTopicOptions(data);
    }
  }

  const showSubTopicOptions = (topicData) => {
    let subTopicHeader = financialJourneySelection.querySelector('.financialJourneySelection__subtopics-header')
    let itemList = financialJourneySelection.querySelector('.financialJourneySelection__subtopics-items');

    let html = '';
    topicData.subTopics.forEach((el) => {
      html += `<label class="financialJourneySelection__subtopics-item">${el.title}</label>`
    })

    subTopicHeader.innerText = topicData.subTopicsTitle;
    itemList.innerHTML = html;
    supTopicContainer.classList.add('is-visible');
    const subtopics = [...financialJourneySelection.querySelectorAll('.financialJourneySelection__subtopics-item')];

    subtopics.forEach((item, i) => {
      item.addEventListener('click', () => {
        showSelectionMap(topicData.subTopics[i], true);
      })
    });
  };

  const getSubTopicIndexByTitle = (subtopics, title) => {
    return subtopics.findIndex((item) => {
      return item.title == title;
    });
  }

  const showSelectionMap = (data, pushState) => {
    if (pushState) {
      window.history.pushState({ last_track: getCurrentTrack(), track: data }, '', '?track=' + data.title);
    }

    financialJourneySelection.classList.add('is-hidden');
    financialJourneyStart.classList.add('is-visible');

    let header = financialJourneyStart.querySelector('.financialJourneyStart__heading');
    let image = financialJourneyStart.querySelector('.financialJourneyStart__img');
    let copy = financialJourneyStart.querySelector('.financialJourneyStart__copy');
    let path = financialJourneyStart.querySelector('.financialJourneyStart__path');

    image.src = data.image;
    header.innerText = data.heading;
    copy.innerText = data.copy;

    let html = ''
    data.path.forEach((el, i) => {
      html +=
        `
          <div class="financialJourneyStart__item">
            <i class="financialJourneyStart__number">${i + 1}</i>
            <a class="financialJourneyStart__link" href="${el.url}">${el.title}</a>
          </div>
        `
    })

    path.innerHTML = html;
    buildPath();
  }

  const getCurrentTrack = () => {
    if (window.history && window.history.state && window.history.state.track) {
      return window.history.state.track;
    }

    return '';
  }

  const getLastTrack = () => {
    if (window.history && window.history.state && window.history.state.last_track) {
      return window.history.state.last_track;
    }

    return null;
  }

  const buildPath = () => {
    const path = financialJourneyStart.querySelector('.financialJourneyStart__path');
    const items = [...financialJourneyStart.querySelectorAll(".financialJourneyStart__item")];
    const counters = [...financialJourneyStart.querySelectorAll(".financialJourneyStart__number")];

    let rows = Math.ceil(items.length / 2);
    let insertionPoint = rows;

    if (items.length % 2 === 0) {
      rows++;
    }

    items[insertionPoint].insertAdjacentHTML(
      "beforebegin",
      '<div class="spacer"></div>'
    );

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    path.insertAdjacentElement("afterbegin", canvas);

    const drawPath = () => {
      if (!blue.prop.media.default.matches) {
        path.style.gridTemplateRows = ``;

      } else {
        path.style.gridTemplateRows = `repeat(${rows}, auto)`;

        const totalCounters = counters.length;

        canvas.height = path.offsetHeight * window.devicePixelRatio;
        canvas.width = path.offsetWidth * window.devicePixelRatio;
        ctx.translate(0.5, 0.5);

        const { first, bottom, top, last } = {
          first: counters[0],
          bottom: counters[Math.ceil(totalCounters / 2) - 1],
          top: counters[Math.ceil(totalCounters / 2)],
          last: counters[totalCounters - 1]
        };

        const points = [
          {
            x: Math.round(first.offsetWidth / 2),
            y: Math.round(first.offsetTop)
          },
          {
            x: Math.round(bottom.offsetWidth / 2),
            y: Math.round(bottom.offsetTop + bottom.offsetHeight * 2)
          },
          {
            x: Math.round(path.offsetWidth / 2),
            y: Math.round(bottom.offsetTop + bottom.offsetHeight * 2)
          },
          {
            x: Math.round(path.offsetWidth / 2),
            y: Math.round(top.offsetTop - top.offsetHeight * 0.75)
          },
          {
            x: Math.round(top.offsetLeft + top.offsetWidth / 2),
            y: Math.round(top.offsetTop - top.offsetHeight * 0.75)
          },
          {
            x: Math.round(last.offsetLeft + last.offsetWidth / 2),
            y: Math.round(last.offsetTop)
          }
        ];

        const connect = ({ x, y }, i, arr) => {
          const next = arr[i + 1];
          if (next) {
            ctx.arcTo(x, y, next.x, next.y, 20);
          } else {
            ctx.lineTo(x, y);
          }
        };

        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.strokeStyle = "#D8D8D8";
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.moveTo(points[0].x, points[0].y);
        points.forEach(connect);
        ctx.stroke();
      }
    };

    // calcRows();
    drawPath();
    window.addEventListener("resize", drawPath);
  }
  
  const urlParams = new URLSearchParams(window.location.search);
  const trackParam = urlParams.get('track');
  
  if (trackParam) {
    topics.every((topic) => {
      let data = JSON.parse(topic.dataset.obj);

      if (data.caption == trackParam) {
        showParentTrack(topic);

        return false;
      }

      var subTopicIndex = getSubTopicIndexByTitle(data.subTopics, trackParam);
      if (subTopicIndex >= 0) {
        showParentTrack(topic, trackParam);

        return false;
      }

      return true;
    });
  }
});

// blue.ready('financialJourneyStart', '.financialJourneyStart', content => {
// });
